import { Injectable } from '@angular/core';
import { BaseService } from '@base/base.service';
import { QuestionStateRule } from '../models/question-state-rule.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class QuestionStateRuleService extends BaseService<QuestionStateRule> {
  serviceUrl = '/api/question-state-rules';

  generateIcon(condition: any): Observable<string | undefined> {
    return this.http.post<{ iconBase64?: string }>('/api/ai-chat/conversations/generate-condition-icon', { condition }).pipe(
      map((response) => response.iconBase64)
    );
  }
}
